import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useEffect, useState } from 'react';
import SuccessModal from '../Common/SuccessModal';
import AddEditCenter from './AddEditCenter';
import { API_CENTERS } from '../Config/ApiUrlConstant';
import { useAuth } from '../AuthContext';

const CenterMgmt = () => {
    const [centerList, setCenterList] = useState([]);
    const [filteredCenters, setFilteredCenters] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const centersPerPage = 10;

    const [filters, setFilters] = useState({
        branch_no: '',
        branch_name: '',
        center_no: '',
        center_name: '',
    });

    const [message, setMessage] = useState('');
    const [successModalVisible, setSuccessModalVisible] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [centerToEdit, setCenterToEdit] = useState(null);
    const [actionType, setActionType] = useState(null);
    const token = localStorage.getItem('token');
    const { logout } = useAuth();

    const closeModal = () => setSuccessModalVisible(false);

    const getAllCenters = async () => {
        try {
            const response = await fetch(API_CENTERS, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
            });

            if (response.status === 401 || response.status === 403) {
                logout();
                return;
            }

            const responseData = await response.json();
            setCenterList(responseData.data);
            setFilteredCenters(responseData.data);
        } catch (error) {
            console.error('Error:', error);
            setMessage('Error getting center');
        }
    };

    useEffect(() => {
        getAllCenters();
    }, []);

    const handleEditClick = (rowData, type) => {
        setCenterToEdit(type === 'edit' ? rowData : null);
        setShowModal(true);
        setActionType(type);
    };

    const handleColumnFilterChange = (e) => {
        const { name, value } = e.target;
        const newFilters = { ...filters, [name]: value };
        setFilters(newFilters);

        const filtered = centerList.filter(center =>
            center.branch_no?.toLowerCase().includes(newFilters.branch_no.toLowerCase()) &&
            center.branch_name?.toLowerCase().includes(newFilters.branch_name.toLowerCase()) &&
            center.center_no?.toLowerCase().includes(newFilters.center_no.toLowerCase()) &&
            center.center_name?.toLowerCase().includes(newFilters.center_name.toLowerCase())
        );

        setFilteredCenters(filtered);
        setCurrentPage(1); // reset to page 1
    };

    // Pagination logic
    const indexOfLastCenter = currentPage * centersPerPage;
    const indexOfFirstCenter = indexOfLastCenter - centersPerPage;
    const currentCenters = filteredCenters.slice(indexOfFirstCenter, indexOfLastCenter);
    const totalPages = Math.ceil(filteredCenters.length / centersPerPage);

    return (
        <div className="container mt-5">
            {/* Header */}
            <div className="row mb-3 align-items-center">
                <div className="col-md-6 col-sm-12 float-left">
                    <h2>Centers List</h2>
                </div>
                <div className="col-md-6 col-sm-12 text-md-end text-sm-start mt-sm-2 mt-md-0 float-right">
                    <button onClick={() => handleEditClick(null, 'add')} className="btn btn-primary width200">
                        Add New Center
                    </button>
                </div>
            </div>

            {/* Table with Column Filters */}
            <div className="table-responsive">
                <table className="table table-bordered table-striped">
                    <thead>
                        <tr>
                            <th>Sr. No</th>
                            <th>Branch No</th>
                            <th>Branch Name</th>
                            <th>Center No</th>
                            <th>Center Name</th>
                            <th>Action</th>
                        </tr>
                        <tr>
                            <th></th>
                            <th>
                                <input
                                    type="text"
                                    name="branch_no"
                                    value={filters.branch_no}
                                    onChange={handleColumnFilterChange}
                                    className="form-control form-control-sm"
                                    placeholder="Search"
                                />
                            </th>
                            <th>
                                <input
                                    type="text"
                                    name="branch_name"
                                    value={filters.branch_name}
                                    onChange={handleColumnFilterChange}
                                    className="form-control form-control-sm"
                                    placeholder="Search"
                                />
                            </th>
                            <th>
                                <input
                                    type="text"
                                    name="center_no"
                                    value={filters.center_no}
                                    onChange={handleColumnFilterChange}
                                    className="form-control form-control-sm"
                                    placeholder="Search"
                                />
                            </th>
                            <th>
                                <input
                                    type="text"
                                    name="center_name"
                                    value={filters.center_name}
                                    onChange={handleColumnFilterChange}
                                    className="form-control form-control-sm"
                                    placeholder="Search"
                                />
                            </th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {currentCenters.length > 0 ? (
                            currentCenters.map((data, index) => (
                                <tr key={index}>
                                    <td>{indexOfFirstCenter + index + 1}</td>
                                    <td>{data.branch_no}</td>
                                    <td>{data.branch_name}</td>
                                    <td>{data.center_no}</td>
                                    <td>{data.center_name}</td>
                                    <td>
                                        <button
                                            onClick={() => handleEditClick(data, 'edit')}
                                            className="btn btn-warning btn-sm"
                                        >
                                            Edit
                                        </button>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="6" className="text-center">No centers found.</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {/* Pagination */}
            <nav className="d-flex justify-content-center">
                <ul className="pagination">
                    {Array.from({ length: totalPages }, (_, i) => (
                        <li key={i} className={`page-item ${currentPage === i + 1 ? 'active' : ''}`}>
                            <button onClick={() => setCurrentPage(i + 1)} className="page-link">
                                {i + 1}
                            </button>
                        </li>
                    ))}
                </ul>
            </nav>

            {/* Modals */}
            {successModalVisible && <SuccessModal message={message} onClose={closeModal} />}
            <AddEditCenter
                showAddEdit={showModal}
                setShowAddEdit={setShowModal}
                centerToEdit={centerToEdit}
                actionType={actionType}
                refreshCenters={getAllCenters}
            />
        </div>
    );
};

export default CenterMgmt;
